// extracted by mini-css-extract-plugin
export var progressBar = "_ju-0";
export var progressBarInner = "_ju-1";